<template>
    <div
        :id="`blast-score-${well._id}`"
        class="blast-score"
        :class="[option, { disabled: !blastScore }]"
    >
        <b-tooltip
            :target="`blast-score-${well._id}`"
            triggers="click"
            :show.sync="showTooltip"
            placement="bottom"
        >
            {{ $translate('feature_not_available') }}
        </b-tooltip>

        <span class="label">{{ $translate('blast') }}</span>

        <h5 v-if="isBlast" class="tick mb-0">
            <i class="fa fa-check" />
        </h5>
        <span v-else class="value">{{ formattedBlastScore }}</span>
    </div>
</template>

<script>
import UIUtils from '../../../business/utils/UIUtils'
import Device from '../../../business/services/Device'
import { MAX_WELL_TIME_HOURS } from '../../../business/const'

export default {
    name: 'BlastScore',
    props: {
        well: {
            type: Object,
            required: true
        },
        option: {
            type: String,
            required: true
        },
        currentWellTimeHours: {
            type: Number,
            default: null
        }
    },
    data: () => ({
        showTooltip: false
    }),
    computed: {
        isDesktop() {
            return !Device.mobileMode
        },
        isBlast() {
            return this.well.isBlast
        },
        inferenceData() {
            return this.well.inferenceData
        },
        isByCurrentHour() {
            return !!this.currentWellTimeHours
        },
        currentHourEven() {
            if (this.isByCurrentHour) {
                const hours =
                    this.currentWellTimeHours <= MAX_WELL_TIME_HOURS
                        ? this.currentWellTimeHours
                        : MAX_WELL_TIME_HOURS

                return 2 * Math.ceil(hours / 2)
            }

            return null
        },
        blastScore() {
            if (!this.isByCurrentHour) {
                return this.inferenceData.blastScore
            }

            const { blastScoreOverTime } = this.inferenceData

            if (!blastScoreOverTime) {
                console.error(`blastScoreOverTime for well id ${this.well._id} is undefined`)
                return
            }

            return blastScoreOverTime[this.currentHourEven]
        },
        formattedBlastScore() {
            return UIUtils.formatScore(this.blastScore) || this.$translate('na')
        }
    },
    watch: {
        showTooltip(shouldShow) {
            if (shouldShow) {
                setTimeout(() => {
                    this.showTooltip = false
                }, 2000)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.blast-score {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    background-color: $dark-4;
    border-radius: $border-radius;

    &.tooltip-option {
        .label {
        }
        .value {
        }
    }
    &.well-card-option {
        .label {
            color: $light;
            font-size: 10.5px;
            font-weight: var(--font-weight-regular);
        }
        .value {
            font-size: 14px;
            font-weight: var(--font-weight-bold);
        }
    }
    &.table-cell-option {
        background-color: transparent;
        cursor: pointer;

        .label {
            display: none;
        }
        .tick {
            font-size: 10pt;
        }
        .value {
            font-size: 10pt;
            font-weight: var(--font-weight-bold);
        }
    }
    &.focused-well-option {
        border-radius: $border-radius;
        cursor: pointer;
        background-color: $dark-4;

        .label {
            font-size: 10pt;
            font-weight: var(--font-weight-regular);
            color: $light;
        }
        .tick {
            font-size: 21pt;
            font-weight: var(--font-weight-bold);
        }
        .value {
            font-size: 18pt;
            font-weight: var(--font-weight-bold);
        }
    }

    @media print {
        background-color: $white !important;
    }
}
</style>
